import { Application } from "../../System/Application/Application";

export function LegalNotice(props) {
    if (props.language === "Fr") {
        return (
            <Application {...props}>
                <div
                    style={{
                        backgroundColor: "#f9f9f9",
                        height: "100%",
                        width: "100%",
                        overflow: "auto",
                        overflow: "auto",
                    }}
                >
                    <div
                        style={{
                            textAlign: "justify",
                            minWidth: "50%",
                            maxWidth: "51vw",
                            padding: "15px 60px",
                            fontFamily: "'Courier New', Courier, monospace",
                        }}
                    >
                        <h1>Mentions légales</h1>

                        <h2>Éditeur du site</h2>
                        <p>
                            Ce site est édité à titre personnel par un
                            particulier. Conformément à l'article 6, III, 2° de
                            la loi n°2004-575 du 21 juin 2004 pour la confiance
                            dans l'économie numérique, l'identité de l'éditeur a
                            été communiquée à l'hébergeur du site.
                        </p>

                        <h2>Contact</h2>
                        <p>
                            L’identité de l’éditeur du site n’est pas rendue
                            publique, conformément aux lois en vigueur. Pour
                            toute demande d’information ou de contact, vous
                            pouvez adresser un message à travers l’hébergeur du
                            site, qui transmettra le cas échéant. Nous mettons
                            également à disposition une adresse mail de contact,
                            mais nous ne garantissons pas de réponse :
                            <span style={{ display: "none" }}>tom</span>
                            <i style={{ display: "none" }}>[arobase]</i>
                            <span style={{ display: "none" }}>boireau</span>
                            <i style={{ display: "none" }}>[point]</i>
                            <span>boireau</span>
                            <i>[point]</i>
                            <span style={{ display: "none" }}>com</span>
                            <span>tom</span>
                            <span style={{ display: "none" }}>tom</span>
                            <i>[arobase]</i>
                            <span>gmail</span>
                            <i style={{ display: "none" }}>[point]</i>
                            <span style={{ display: "none" }}>com</span>
                            <i>[point]</i>
                            <span>com</span>.
                        </p>

                        <h2>Hébergement</h2>
                        <p>
                            Le site est hébergé par :<br />
                            OVH SAS
                            <br />
                            2 rue Kellermann
                            <br />
                            59100 Roubaix
                            <br />
                            France
                            <br />
                            <a href="https://www.ovh.com">www.ovh.com</a>
                        </p>

                        <h2>Propriété intellectuelle</h2>
                        <p>
                            L’ensemble des contenus présents sur ce site
                            (textes, code, éléments graphiques, etc.) est
                            protégé par le droit d’auteur. Sauf mention
                            contraire, ces contenus sont la propriété de leur(s)
                            auteur(s) et ne peuvent être reproduits, modifiés ou
                            utilisés sans autorisation préalable.
                        </p>

                        <p>
                            Certains documents PDF diffusés sur le site sont la
                            propriété de plusieurs auteurs. Ils sont publiés
                            avec leur autorisation ou dans le respect de leur
                            licence d’utilisation.
                        </p>

                        <p>
                            Les images présentes sur le site proviennent pour la
                            plupart de sources libres de droits, notamment{" "}
                            <a
                                href="https://commons.wikimedia.org"
                                target="_blank"
                                rel="noopener"
                            >
                                Wikimedia Commons
                            </a>
                            . Chaque image respecte les conditions de la licence
                            correspondante (attribution, usage, etc.). En cas de
                            doute ou de réclamation, merci de nous contacter.
                        </p>

                        <p>
                            Le logo de GitHub appartient à GitHub, Inc. et est
                            utilisé conformément à leurs conditions
                            d'utilisation.
                        </p>

                        <p>
                            Le logo de LinkedIn appartient à LinkedIn
                            Corporation et est utilisé conformément à leurs
                            conditions d'utilisation.
                        </p>

                        <h2>Responsabilité</h2>
                        <p>
                            L’éditeur s’efforce de fournir des informations
                            exactes et à jour, mais ne saurait être tenu
                            responsable d’éventuelles erreurs ou omissions, ni
                            de l’usage qui pourrait être fait des informations
                            diffusées sur le site.
                        </p>

                        <h2>Données personnelles</h2>
                        <p>
                            Ce site ne collecte aucune donnée personnelle. Aucun
                            formulaire, système de suivi ou analyse d’audience
                            n’est mis en place.
                        </p>

                        <h2>Cookies</h2>
                        <p>
                            Ce site n’utilise aucun cookie de suivi ou de mesure
                            d’audience. Seul un cookie technique, généré
                            automatiquement par l’hébergeur OVH, peut être
                            utilisé pour assurer la répartition de charge (load
                            balancing). Ce cookie est exempté de consentement
                            selon les recommandations de la CNIL.
                        </p>

                        <h2>Contact</h2>
                        <p>
                            Pour toute demande concernant le site ou ses
                            contenus, vous pouvez adresser un message à travers
                            l’hébergeur, qui transmettra le cas échéant.
                        </p>
                    </div>
                </div>
            </Application>
        );
    }

    return (
        <Application {...props}>
            <div
                style={{
                    backgroundColor: "#f9f9f9",
                    height: "100%",
                    width: "100%",
                    overflow: "auto",
                    overflow: "auto",
                }}
            >
                <div
                    style={{
                        textAlign: "justify",
                        minWidth: "50%",
                        maxWidth: "51vw",
                        padding: "15px 60px",
                        fontFamily: "'Courier New', Courier, monospace",
                    }}
                >
                    <h1>Legal Notice</h1>

                    <h2>Site ownership</h2>
                    <p>
                        This website is published by a private individual for
                        personal and non-commercial purposes. The identity of
                        the site owner is not publicly disclosed, in accordance
                        with applicable laws.
                    </p>

                    <h2>Contact</h2>
                    <p>
                        The identity of the site owner is not disclosed in
                        accordance with the law in France. For any inquiries or
                        contact requests, you can send a message through the
                        hosting provider, who will forward it if necessary. We
                        also provide an email address for contact, but we do not
                        guarantee a response:
                        <span style={{ display: "none" }}>tom</span>
                        <i style={{ display: "none" }}>[at]</i>
                        <span style={{ display: "none" }}>boireau</span>
                        <i style={{ display: "none" }}>[dot]</i>
                        <span>boireau</span>
                        <i>[dot]</i>
                        <span style={{ display: "none" }}>com</span>
                        <span>tom</span>
                        <span style={{ display: "none" }}>tom</span>
                        <i>[at]</i>
                        <span>gmail</span>
                        <i style={{ display: "none" }}>[dot]</i>
                        <span style={{ display: "none" }}>com</span>
                        <i>[dot]</i>
                        <span>com</span>.
                    </p>

                    <h2>Hosting provider</h2>
                    <p>
                        This site is hosted by: OVH SAS
                        <br />
                        2 rue Kellermann
                        <br />
                        59100 Roubaix
                        <br />
                        France
                        <br />
                        <a href="https://www.ovh.com">www.ovh.com</a>
                    </p>

                    <h2>Copyright</h2>
                    <p>
                        Unless otherwise stated, all content on this website is
                        protected by copyright and may not be reproduced,
                        modified, or distributed without prior permission from
                        the respective copyright holders.
                    </p>

                    <p>
                        Some images are sourced from platforms such as{" "}
                        <a
                            href="https://commons.wikimedia.org"
                            target="_blank"
                            rel="noopener"
                        >
                            Wikimedia Commons
                        </a>{" "}
                        and are used in compliance with their respective
                        licenses.
                    </p>

                    <p>
                        PDF documents available on this site are either original
                        works or shared with the explicit permission of their
                        authors.
                    </p>

                    <h2>Disclaimer</h2>
                    <p>
                        The information provided on this website is for general
                        informational purposes only. No liability is accepted
                        for errors or omissions, or for the use of information
                        published here.
                    </p>

                    <h2>Cookies</h2>
                    <p>
                        This website does not use tracking cookies. A technical
                        cookie may be used by the hosting provider (OVH) for
                        load balancing purposes only.
                    </p>

                    <h2>Data protection</h2>
                    <p>
                        No personal data is collected or stored through this
                        website. There are no contact forms, subscriptions, or
                        analytics tools in use.
                    </p>
                </div>
            </div>
        </Application>
    );
}
